import script from "./PlanCard20676.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlanCard20676.vue?vue&type=script&setup=true&lang=ts"

import "./PlanCard20676.vue?vue&type=style&index=0&id=b6251a44&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6251a44"]])

export default __exports__